module.exports = __webpack_public_path__ + "img/icon(18).372588fc.png";